module.exports = __webpack_public_path__ + "static/media/cont513.435efd0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont513.mp4
// module id = zKAU
// module chunks = 0